import type { IconProps } from "./types";

export function SideOpen({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 0C18.6569 0 20 1.34315 20 3V13C20 14.6051 18.7394 15.9158 17.1543 15.9961L17 16H3L2.8457 15.9961C1.26055 15.9158 0 14.6051 0 13V3C0 1.34315 1.34315 6.44256e-08 3 0H17ZM3 1.7998C2.33726 1.7998 1.7998 2.33726 1.7998 3V13C1.7998 13.6627 2.33726 14.2002 3 14.2002H6.25V1.7998H3ZM8.0498 14.2002H17C17.6627 14.2002 18.2002 13.6627 18.2002 13V3C18.2002 2.33726 17.6627 1.7998 17 1.7998H8.0498V14.2002ZM10.3633 4.36328C10.7148 4.01186 11.2853 4.01183 11.6367 4.36328L14.6367 7.36328L14.6982 7.43164C14.9866 7.78512 14.9662 8.30718 14.6367 8.63672L11.6367 11.6367C11.2853 11.9882 10.7148 11.9881 10.3633 11.6367C10.0118 11.2852 10.0118 10.7148 10.3633 10.3633L12.7266 8L10.3633 5.63672C10.0118 5.28525 10.0118 4.71475 10.3633 4.36328Z"
        fill={currentColor}
        transform="translate(2 4)"
      />
    </svg>
  );
}
